import React from 'react'
// @ts-ignore
import { Table as NbTable, QuestionMarkOutlined } from '@netbasequid/core'
import { ColDef, TableContext } from './types'

export const getExplanationConfigs = (tooltipContent: React.ReactNode) => ({
  render: <QuestionMarkOutlined fontSize={14} />,
  tooltipContent
})

const HeaderRenderer = ({
  testId,
  colDef,
  context
}: {
  testId?: string
  colDef: ColDef<any, any, any>
  context: TableContext<any>
}): React.ReactElement => {
  const {
    customHeaderRender,
    headerProps,
    headerText,
    children,
    sortable,
    comparator,
    field,
    defaultOrder
  } = colDef
  const { colspan, textAlign, icon, className, style, contentStyle, textStyle } = headerProps || {}
  const defaultColspan = children?.length || 1

  const enableSort = sortable || !!comparator

  return (
    <NbTable.TableHeader
      testId={testId}
      defaultOrder={defaultOrder}
      icon={icon}
      colspan={colspan || defaultColspan}
      textAlign={textAlign}
      field={enableSort ? field : undefined}
      className={className}
      style={style}
      contentStyle={contentStyle}
      textStyle={textStyle}>
      {customHeaderRender?.(context) || headerText}
    </NbTable.TableHeader>
  )
}

export default HeaderRenderer
